import React from 'react';
import logoImg from '../../assets/logo.png';

export default function Logo({ size = 100 }) {
  return (
    <img
      src={logoImg}
      alt="Wijjdan Logo"
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
}
